import { Resource } from '../index'
import GroupWork from '@material-ui/icons/GroupWork'
import { PERMISSION_TYPE, USER_KEY } from '@/constants'
import list from './ChainList'
import create from './ChainCreate'
import edit from './ChainEdit'

const { ADMIN } = PERMISSION_TYPE

export default {
  edit,
  list,
  create,
  name: '_chains',
  permission: [ADMIN],
  options: { label: 'Rede' },
  icon: GroupWork,
} as Resource
